(function (upp) {
    'use strict';

    upp.controller('upp.tripadvisor.TripAdvisorCtrl', ['$scope', 'tripAdvisorService', 'appi', '$sce',
            function ($scope, tripAdvisorService, appi, $sce) {

                appi.ui.showPageLoadingMsg();

                $scope.content = '';

                tripAdvisorService.get().then(function(data) {
                    $scope.content = $sce.trustAsHtml(data);
                    $scope.hasContent = data && data.length > 0;
                    appi.ui.hidePageLoadingMsg();
                });
            }]);
})(upp);


// WEBPACK FOOTER //
// ./src/app/modules/tripadvisor/controllers/tripadvisor-controller.js